module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title top-margin"
  }, [_vm._v("Note list")]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), (_vm.isBulkRedemptionVisible) ? _c('bulk-redemption', {
    attrs: {
      "accountId": _vm.accountId
    },
    on: {
      "close": _vm.closeBulkRedemption,
      "completed": _vm.onBulkRedemptionCompleted
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isBulkTransferVisible) ? _c('bulk-transfer', {
    attrs: {
      "accountId": _vm.accountId
    },
    on: {
      "close": _vm.closeBulkTransfer,
      "completed": _vm.onBulkTransferCompleted
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row bottom-margin"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg top-margin",
    attrs: {
      "type": "button",
      "disabled": _vm.disableInvestment
    },
    on: {
      "click": function($event) {
        _vm.goToPurchaseInvestmentNote()
      }
    }
  }, [_vm._v("\n        Make an investment\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-lg top-margin ml-sm",
    attrs: {
      "type": "button",
      "disabled": !_vm.hasOpenNotes,
      "title": "Redeem every open note on this account in one request"
    },
    on: {
      "click": function($event) {
        _vm.openBulkRedemption()
      }
    }
  }, [_vm._v("\n        Redeem/approve all open notes\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-outline btn-lg top-margin ml-sm",
    attrs: {
      "type": "button",
      "disabled": !_vm.hasTransferableNotes,
      "title": "Transfer every note on this account to another account in one request"
    },
    on: {
      "click": function($event) {
        _vm.openBulkTransfer()
      }
    }
  }, [_vm._v("\n        Transfer all notes\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 text-right account-balance-column"
  }, [_c('br', {
    staticClass: "panel-subtitle"
  }), _vm._v(" Current account balance: "), _c('strong', {
    staticClass: "amountBalance"
  }, [_vm._v(_vm._s(_vm.formatAmount(_vm.currentAmountBalance)))])])]), _vm._v(" "), (_vm.notes.length === 0) ? _c('div', {
    staticClass: "row top-margin"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row mt-lg mb-lg"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [(_vm.notes.length > 0) ? _c('div', {
    class: {
      'table-fixed-header--md table-fixed-column cols-11': _vm.notes.length > 6, 'table-responsive': true, 'bottom-margin': true
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center sticky-col"
  }, [_c('div', {
    staticClass: "note-sort-title small-container",
    on: {
      "click": function($event) {
        _vm.sortNotesById('noteId')
      }
    }
  }, [_c('span', [_vm._v("Note number")]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('noteId')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_c('div', {
    staticClass: "note-sort-title small-container",
    on: {
      "click": function($event) {
        _vm.sortNotes('originalBalance')
      }
    }
  }, [_c('span', [_vm._v("Original amount")]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('originalBalance')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_c('div', {
    staticClass: "note-sort-title small-container",
    on: {
      "click": function($event) {
        _vm.sortNotes('currentBalance')
      }
    }
  }, [_c('span', [_vm._v("Current amount")]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('currentBalance')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "note-sort-title small-container",
    on: {
      "click": function($event) {
        _vm.sortNotes('interestRate')
      }
    }
  }, [_c('span', {
    staticClass: "small-field"
  }, [_vm._v("Rate")]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('interestRate')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "note-sort-title small-container",
    on: {
      "click": function($event) {
        _vm.sortNotes('interestTerm')
      }
    }
  }, [_c('span', {
    staticClass: "small-field"
  }, [_vm._v("Term")]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('interestTerm')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "note-sort-title small-container",
    on: {
      "click": function($event) {
        _vm.sortNotes('purchasedOn')
      }
    }
  }, [_c('span', {
    staticClass: "small-field"
  }, [_vm._v("Purchase date")]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('purchasedOn')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "note-sort-title small-container",
    on: {
      "click": function($event) {
        _vm.sortNotes('openedOn')
      }
    }
  }, [_c('span', {
    staticClass: "small-field"
  }, [_vm._v("Open date")]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('openedOn')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "note-sort-title small-container",
    on: {
      "click": function($event) {
        _vm.sortNotes('maturityDate')
      }
    }
  }, [_c('span', {
    staticClass: "small-field"
  }, [_vm._v("Maturity date")]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('maturityDate')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "note-sort-title small-container",
    on: {
      "click": function($event) {
        _vm.sortByStatus()
      }
    }
  }, [_c('span', {
    staticClass: "small-field"
  }, [_vm._v("Status")]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('status')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "note-sort-title large-container",
    on: {
      "click": function($event) {
        _vm.sortNotesById('legacyNoteID')
      }
    }
  }, [_c('span', [_vm._v("Legacy note number")]), _vm._v(" "), _c('em', {
    class: _vm.sortIconStyle('legacyNoteID')
  })])]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("View details")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.orderedNotes), function(note, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center sticky-col"
    }, [_vm._v(_vm._s(note.noteId))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatAmount(note.originalBalance)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatAmount(note.currentBalance)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatRate(note.interestRate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatTerm(note.interestTerm)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(note.purchasedOn)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(note.openedOn)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(note.maturityDate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(note.status == 'cancelled') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Cancelled")]) : _vm._e(), _vm._v(" "), (note.status == 'failed') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Failed")]) : _vm._e(), _vm._v(" "), (note.status == 'closed') ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("Closed")]) : _vm._e(), _vm._v(" "), (note.status == 'pending') ? _c('span', {
      staticClass: "label label-warning"
    }, [_vm._v("Pending")]) : _vm._e(), _vm._v(" "), (note.status == 'open') ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("Open")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(note.legacyNoteID))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.goToViewDetail(note)
        }
      }
    }, [_vm._v("View details")])])])
  }))])]) : _vm._e()])]), _vm._v(" "), (_vm.displayAlertForUpcomingTransactionsWithAction) ? _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("Click "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.gotToUpcomingTransactionsSegment($event)
      }
    }
  }, [_vm._v("here")]), _vm._v(" to review the actions received for the transactions.")])])])]) : _vm._e(), _vm._v(" "), (_vm.displayAlertForUpcomingTransactionsWithNoAction) ? _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(2), _vm._v(" "), _c('p', [_vm._v("Click "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.gotToUpcomingTransactionsSegment($event)
      }
    }
  }, [_vm._v("here")]), _vm._v(" to see the transactions that require action.")])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "alert alert-info alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n        No notes were found.\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('em', {
    staticClass: "icon-info pr-sm"
  }), _vm._v("Please note this account has upcoming transactions that have received action.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('em', {
    staticClass: "icon-info pr-sm"
  }), _vm._v("Please note this account has upcoming transactions that require action.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bd33c76","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountNotes.vue
// module id = 2182
// module chunks = 1